export default __webpack_public_path__ + "static/media/dollar-sign-ai.aa6733fd.svg";